import { render } from "./WhitelabelOption.vue?vue&type=template&id=097968db&scoped=true"
import script from "./WhitelabelOption.vue?vue&type=script&lang=js"
export * from "./WhitelabelOption.vue?vue&type=script&lang=js"

import "./WhitelabelOption.vue?vue&type=style&index=0&id=097968db&lang=scss&scoped=true"

import exportComponent from "/home/forge/staging.hikeseo.co/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-097968db"]])

export default __exports__